export default __webpack_public_path__ + "static/media/iso14001.dce8c3c0.jpg";